
// Main Medical Knowledge Service - refactored and simplified
export type { MedicalKnowledgeEntry, SyncStatus } from "./types";
export { MedicalSearchService } from "./medicalSearch";
export { MedicalAnalysisService } from "./medicalAnalysis";
export { MedicalRelevanceService } from "./medicalRelevance";
export { MedicalSyncService } from "./medicalSync";
export { ICD11Service, type ICD11Entry } from "./icd11Service";

// Legacy compatibility - re-export main service as MedicalKnowledgeService
import { MedicalSearchService } from "./medicalSearch";
import { MedicalAnalysisService } from "./medicalAnalysis";
import { MedicalSyncService } from "./medicalSync";

export class MedicalKnowledgeService {
  static searchRelevantKnowledge = MedicalSearchService.searchRelevantKnowledge;
  static getClinicalGuidelines = MedicalSearchService.getClinicalGuidelines;
  static getDrugSafetyInfo = MedicalSearchService.getDrugSafetyInfo;
  static getEnhancedAnalysis = MedicalAnalysisService.getEnhancedAnalysis;
  static getSyncStatus = MedicalSyncService.getSyncStatus;
  static triggerSync = (apiSource: 'pubmed' | 'trip' | 'openfda' | 'dailymed' | 'clinicaltrials' | 'icd11') => MedicalSyncService.triggerSync(apiSource);
}
